import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { CommonService } from '@core/services/common-service/common.service';
import { GlobalConstants } from '@environments/global-Variables';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';
import { DetailsSuccessModal } from '../details-success-modal/details-success-modal.component';
import { RequestApprovalModalComponent } from '../request-approval-modal/request-approval-modal.component';
import { ViewHistoryModalComponent } from '../view-history-modal/view-history-modal.component';

@Component({
  selector: 'weaccess-revoke-system-access',
  templateUrl: './revoke-system-access.component.html',
  styleUrls: ['./revoke-system-access.component.scss']
})
export class RevokeSystemAccessComponent {

  globalConstants = GlobalConstants;

  dropdownData: any[] = [];
  settings: IDropdownSettings = {};
  revokeSystemAccessform!: FormGroup;
  selectedItems: any[] = [];
  appList: any;
  staffList: any;
  viewHistoryModalRef!: BsModalRef;
  systemAccessShow: boolean = true;

  myStaffSubscription!: Subscription;
  myDepartmentSubscription!: Subscription;
  accessRequestSubmitSubscription!: Subscription;
  getApplicationSubscription!: Subscription;
  accessData: any;
  countDataSubscription!: Subscription;
  countData: any;
  bsModalRef: any;
  userRole: any;
  nonEmployeeFlag: boolean = false;

  constructor(
    private newSystemAccessModalRef: BsModalRef,
    private fb: FormBuilder,
    private modalService: BsModalService,
    private commonService: CommonService,
    private toastService: ToastrService) {
    this.accessData = this.modalService.config.initialState;
    this.userRole = localStorage.getItem(GlobalConstants?.USER_ROLE_KEY)
    this.userRole = JSON.parse(window.atob(this.userRole));
    if (this.userRole?.includes(this.globalConstants.ROLE_NON_EMPLOYEE)) {
      this.nonEmployeeFlag = true;
    }
  }

  radioValue = 'mySelf';

  ngOnInit() {
    this.getRequestFormOptions(0, 'mySelf');
    this.getCounts();
    this.settings = {
      idField: 'appId',
      textField: 'name',
    };

    this.revokeSystemAccessform = this.fb.group({
      requestTypeMode: ['mySelf'],
      selectedApps: [, [Validators.required]],
      accessJustification: [, [Validators.required]],
      staffName: [, [Validators.required]]
    });
  }

  /** Getting field dropdown options from common services */
  getRequestFormOptions(personId: any, type: any) {
    let personData = this.commonService.getPersonData();
    let appRequestParams: any;
    if (this.accessData?.data?.personFlag === 'true') {
      appRequestParams = {
        personId: this.accessData?.data?.personData.personId,
        requestType: 102
      }
    } else {
      if (type === 'mySelf') {
        appRequestParams = {
          personId: personData.personId,
          requestType: 102
        }
      } else {
        appRequestParams = {
          personId: personId,
          requestType: 102
        }
      }
    }

    this.getApplicationSubscription = this.commonService.getApplicationData(appRequestParams).subscribe((applicationListData: any) => {
      this.appList = applicationListData;
    });
  }

  /** Get count for side navigation bar count update */
  getCounts() {
    this.countDataSubscription = this.commonService.getCounts('').subscribe((data: any) => {
      this.countData = data;
    });
  }

  /** Radio button change implementation */
  onItemChange(e: any) {
    this.radioValue = e.target.value;
    if (this.radioValue === 'myStaff') {
      this.myStaffSubscription = this.commonService.getMyStaffList('').subscribe((res: any) => {
        this.clearForm();
        this.staffList = res;
      });
    } else if (this.radioValue === 'myDepartment') {
      this.myDepartmentSubscription = this.commonService.getMyDepartmentList('').subscribe((res: any) => {
        this.clearForm();
        this.staffList = res;
      });
    } else if (this.radioValue === 'mySelf') {
      this.getRequestFormOptions(0, 'mySelf');
    }
  }

  /** Modal Close functionality */
  onClose() {
    this.newSystemAccessModalRef.hide();
  }

  /** Clear form values functionality */
  clearForm() {
    let clearFormValues = {
      staffName: null,
      selectedApps: null,
      accessJustification: null
    }
    this.revokeSystemAccessform.patchValue(clearFormValues);
  }

  /** View history modal */
  showViewHistoryModal(): void {
    let modalData: any
    if (this.accessData?.data?.personFlag === 'true') {
      modalData = {
        data: {
          'type': '',
          'personID': this.accessData?.data?.personData.personId,
          'personName': this.accessData?.data?.personData?.firstName + ' ' + this.accessData?.data?.personData?.lastName,
        }
      }
    } else {
      modalData = {
        data: {
          'type': this.radioValue,
          'personID': this.revokeSystemAccessform.value['staffName'],
          'personName': this.getFieldDataByID('staffName', this.staffList, this.revokeSystemAccessform.value['staffName']),
        }
      }
    }

    this.viewHistoryModalRef = this.modalService.show(ViewHistoryModalComponent, {
      animated: true,
      backdrop: 'static',
      class: 'modal-xl modal-dialog-centered',
      initialState: modalData
    });
    this.systemAccessShow = false;
    this.viewHistoryModalRef.onHide?.subscribe((res) => {
      this.systemAccessShow = true;
    })
  }

  /** Get field name by Option ID */
  getFieldDataByID(type: any, OptionsData: any, value: any) {
    if (type === 'staffName') {
      return OptionsData?.filter((s: any) => s.personId === value)[0]?.fullName ? OptionsData?.filter((s: any) => s.personId === value)[0]?.fullName : '-';
    }
  }

  /** Open confirmation modal implementation */
  openConfirmModal(type: any) {
    const modalData: any = {
      data: {
        'type': 'confirm',
        'status': '',
        'requestType': type
      }
    }
    this.systemAccessShow = false;
    this.bsModalRef = this.modalService.show(RequestApprovalModalComponent, {
      animated: true,
      backdrop: 'static',
      class: 'modal-lg modal-dialog-centered',
      initialState: modalData
    });
    this.bsModalRef.onHide?.subscribe((res: any) => { });

    this.bsModalRef.content.requestApprovalEvent.subscribe((data: any) => {
      if (data?.type === 'Cancel') {
        this.systemAccessShow = true;
      } else if (data?.type === 'Confirm') {
        this.systemAccessShow = true;
        this.submitAccessRequest(type);
      }
    });
  }

  /** Submit request for new system access API implementation */
  submitAccessRequest(type: any) {
    let selectedAppID: any = [];
    if (this.revokeSystemAccessform?.value['selectedApps']) {
      this.revokeSystemAccessform?.value['selectedApps']?.forEach((appItem: any) => {
        selectedAppID.push(appItem.appId);
      });
    }
    let accessRequestData: any;
    if (this.accessData?.data?.personFlag === 'true') {
      accessRequestData = {
        "personid": this.accessData?.data?.personData.personId,
        "appIdSelected": selectedAppID,
        "statusId": this.globalConstants.WORKFLOW_REQUEST_CREATED,
        "appJustification": this.revokeSystemAccessform?.value['accessJustification'],
        "modifiedPersonid": 0,
        "requestTypeId": this.globalConstants.WORKFLOW_REVOKE_SYSTEM_ACCESS_REQUEST
      }
    } else {
      if (this.radioValue === 'mySelf') {
        accessRequestData = {
          "personid": 0,
          "appIdSelected": selectedAppID,
          "statusId": this.globalConstants.WORKFLOW_REQUEST_CREATED,
          "appJustification": this.revokeSystemAccessform?.value['accessJustification'],
          "modifiedPersonid": 0,
          "requestTypeId": this.globalConstants.WORKFLOW_REVOKE_SYSTEM_ACCESS_REQUEST
        }
      } else {
        accessRequestData = {
          "personid": this.revokeSystemAccessform.value['staffName'],
          "appIdSelected": selectedAppID,
          "statusId": this.globalConstants.WORKFLOW_REQUEST_CREATED,
          "appJustification": this.revokeSystemAccessform?.value['accessJustification'],
          "modifiedPersonid": 0,
          "requestTypeId": this.globalConstants.WORKFLOW_REVOKE_SYSTEM_ACCESS_REQUEST
        }
      }
    }

    if (type === this.globalConstants?.SUSPEND_REVOKE_SYS_ACCESS) {
      accessRequestData['requestTypeId'] = this.globalConstants.WORKFLOW_SUSPEND_SYSTEM_ACCESS_REQUEST;
    } else if (type === this.globalConstants?.REVOKE_REVOKE_SYS_ACCESS) {
      accessRequestData['requestTypeId'] = this.globalConstants.WORKFLOW_REVOKE_SYSTEM_ACCESS_REQUEST;
    }

    this.accessRequestSubmitSubscription = this.commonService.submitSystemAccessRequest(accessRequestData, '').subscribe((data: any) => {
      this.commonService.requestChangeItemHandler(true);

      let modalData: any;
      if (type === this.globalConstants?.SUSPEND_REVOKE_SYS_ACCESS) {
        modalData = {
          data: {
            'data': 'success',
            'message': this.globalConstants?.SYSTEM_SUS_ACCESS_SUBMT_MSG,
            'subMessage': this.globalConstants?.SYSTEM_ACCESS_SUPR_APPR_MSG,
            'subSubMessage': this.globalConstants?.SYSTEM_ACCESS_SUPR_SUB_MSG,
            'status': 'submitData',
            'actionType': 'submitData'
          }
        };
      } else if (type === this.globalConstants?.REVOKE_REVOKE_SYS_ACCESS) {
        modalData = {
          data: {
            'data': 'success',
            'message': this.globalConstants?.SYSTEM_REV_ACCESS_SUBMT_MSG,
            'subMessage': this.globalConstants?.SYSTEM_ACCESS_SUPR_APPR_MSG,
            'subSubMessage': this.globalConstants?.SYSTEM_ACCESS_SUPR_SUB_MSG,
            'status': 'submitData',
            'actionType': 'submitData'
          }
        };
      }
      this.bsModalRef = this.modalService.show(DetailsSuccessModal, {
        animated: true,
        backdrop: 'static',
        class: 'modal-dialog modal-dialog-centered modal-dialog-sweet-alert',
        initialState: modalData
      })
      this.commonService.countChangeItemHandler(true);
      this.onClose();
    }, (error: any) => {
      const modalData: any = {
        data: {
          'data': 'error',
          'message': '',
          'status': 'submitData',
          'actionType': 'submitData'
        }
      }
      if (type === this.globalConstants?.SUSPEND_REVOKE_SYS_ACCESS) {
        modalData.data.message = this.globalConstants?.SYSTEM_SUS_ACCESS_ERR_MSG;
      } else if (type === this.globalConstants?.REVOKE_REVOKE_SYS_ACCESS) {
        modalData.data.message = this.globalConstants?.SYSTEM_REV_ACCESS_ERR_MSG;
      }
      if (error?.status === 409) {
        modalData.data.message = error.error;
      }

      this.bsModalRef = this.modalService.show(DetailsSuccessModal, {
        animated: true,
        backdrop: 'static',
        class: 'modal-dialog modal-dialog-centered modal-dialog-sweet-alert',
        initialState: modalData
      });
    });
  }

  /** Getting app details and getting the request options */
  getAppDetails() {
    if (this.revokeSystemAccessform.value['staffName']) {
      let personData = {
        selectedApps: null
      }
      this.revokeSystemAccessform.patchValue(personData);
      this.getRequestFormOptions(this.revokeSystemAccessform.value['staffName'], '');
    }
  }

  /** Getting form valid status */
  getFormValidStatus() {
    if (this.revokeSystemAccessform.value['requestTypeMode'] === 'mySelf' && this.revokeSystemAccessform.value['accessJustification']) {
      if (this.revokeSystemAccessform.value['selectedApps']) {
        return true;
      } else {
        return false;
      }
    } else {
      if (this.revokeSystemAccessform.value['selectedApps'] && this.revokeSystemAccessform.value['staffName'] && this.revokeSystemAccessform.value['accessJustification']) {
        return true;
      } else {
        return false;
      }
    }
  }

}
